import React, { createContext, useContext, useState } from "react";
import moment from "moment";
import { ORDER_STATE_ALL } from "../constants/string";

const GetCurrentDate = (separator = "-") => {
    return moment().format(`YYYY${separator}MM${separator}DD`);
  };

const DateContext = createContext();

export const useDate = () => {
    return useContext(DateContext);
}


export const DateProvider = ({children}) => {
    const [startDate, setStartDate] = useState(GetCurrentDate("-"));
    const [endDate, setEndDate] = useState(GetCurrentDate("-"));
    const [filter, setFilter] = useState([ORDER_STATE_ALL]);
    return(
        <DateContext.Provider value = {{startDate, endDate, setStartDate, setEndDate, filter, setFilter}}>
            {children}
        </DateContext.Provider>
    )

}